@if (showBanner) {
  <div
    class="environment-banner"
    [ngClass]="'banner-' + bannerColor"
    role="banner"
    [attr.aria-label]="'You are viewing the ' + environmentName + ' environment'">
    <span class="banner-text">{{ environmentName }} Environment</span>
  </div>
}
